import { motion, useReducedMotion } from "framer-motion";
import { assets, kitSpecs } from "../../data/sep26Data";
import { EASE_OUT } from "./hooks";

export const Traje26 = () => {
  const reduce = useReducedMotion();
  return (
    <section id="traje" data-testid="s26-traje" className="section-pad" style={{ background: "var(--navy-deep)" }}>
      <div className="wrap">
        <div className="grid items-center gap-12 lg:grid-cols-[1.25fr_1fr]">
          <motion.div
            className="relative aspect-[16/10] overflow-hidden"
            style={{ borderRadius: "clamp(120px, 22vw, 260px) 18px 18px clamp(120px, 22vw, 260px)" }}
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: EASE_OUT }}
          >
            <video
              className="h-full w-full object-cover"
              src={assets.kitVideo}
              poster="/temporada-sep26/traje-poster.jpg"
              autoPlay={!reduce}
              muted
              loop
              playsInline
              preload="metadata"
              aria-label="Video del traje de la temporada en una vitrina"
              data-testid="s26-traje-video"
            />
          </motion.div>

          <div>
            <h2 className="display text-[clamp(48px,7vw,104px)]">
              El traje <span style={{ color: "var(--gold)" }}>2026</span>
            </h2>
            <p className="serif mt-5 max-w-[30ch] text-[clamp(20px,2vw,26px)]" style={{ color: "var(--muted)" }}>
              Azul profundo, oro y el escudo de Allende al pecho.
            </p>

            <dl className="mt-10 divide-y" style={{ borderTop: "1px solid var(--line)" }}>
              {kitSpecs.map((s) => (
                <div key={s.title} className="py-5" style={{ borderColor: "var(--line)" }}>
                  <dt className="display text-[1.7rem]">{s.title}</dt>
                  <dd className="mt-1" style={{ color: "var(--muted)" }}>{s.text}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>

      </div>
    </section>
  );
};
